// @flow
export const size = {
  desktop: '2560px',
  laptop: '1440px',
  laptopL: '1920px',
  mobileL: '480px',
  mobileM: '375px',
  mobileS: '320px',
  tablet: '768px',
  tabletL: '1024px',
}

export const device = {
  desktop: `(max-width: ${size.desktop})`,
  desktopL: `(max-width: ${size.desktop})`,
  laptop: `(max-width: ${size.laptop})`,
  laptopL: `(max-width: ${size.laptopL})`,
  mobileL: `(max-width: ${size.mobileL})`,
  mobileM: `(max-width: ${size.mobileM})`,
  mobileS: `(max-width: ${size.mobileS})`,
  tablet: `(max-width: ${size.tablet})`,
  tabletL: `(max-width: ${size.tabletL})`,
}
